import React from 'react';
import proptypes from 'prop-types';
const { node, arrayOf, oneOfType, string, shape, bool } = proptypes;

import {
  BrowserRouter as ReactBrowserRouter,
} from 'react-router-dom';
import { CrossExperience } from './CrossExperience';

const BrowserRouter = ({ children, experience = null, disableCrossExpCheck = false }) => {

  return (
    <ReactBrowserRouter>
      <CrossExperience experience={experience} disableCrossExpCheck={disableCrossExpCheck}>
        {children}
      </CrossExperience>
    </ReactBrowserRouter>
  );
};

BrowserRouter.propTypes = {
  children: oneOfType([node, arrayOf(node)]).isRequired,
  /**
   * The current nucleus experience. This is used to call full page reloads
   * when there is a pushState or replaceState SPA transition.
   *
   * Leave null to prevent window.location change on SPA transitions cross experience
   */
  experience: string,
  disableCrossExpCheck: bool,
};

export { BrowserRouter };
